import { START_LOCATION } from "vue-router";

// Show a progress cursor during client-side navigations. With the instant
// scroll-to-top in app/router.options.ts the user briefly sees the top of the
// old page while the new route resolves; the cursor signals that a load is in
// flight (alongside NuxtLoadingIndicator).
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const setLoading = (on: boolean) => {
    document.documentElement.classList.toggle("route-loading", on);
  };

  // beforeEach fires the moment a navigation is requested - before the route's
  // JS chunks download, which on a cold cache is most of the wait. Waiting for
  // page:start instead would miss that phase entirely.
  router.beforeEach((to, from) => {
    if (from === START_LOCATION) return; // initial load / hydration
    // Query-only changes (facets, filters) don't re-create the page component,
    // so page:finish never fires for them - don't turn the cursor on.
    if (to.path === from.path) return;
    setLoading(true);
  });

  nuxtApp.hook("page:finish", () => setLoading(false));

  // Aborted/failed navigations never reach page:finish; don't leave the
  // cursor stuck.
  router.afterEach((_to, _from, failure) => {
    if (failure) setLoading(false);
  });
  router.onError(() => setLoading(false));
  nuxtApp.hook("app:error", () => setLoading(false));
  nuxtApp.hook("vue:error", () => setLoading(false));
});
